"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var s = require("./PaymentMethodLayout.scss");
var PaymentMethodLayout = (function (_super) {
    __extends(PaymentMethodLayout, _super);
    function PaymentMethodLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentMethodLayout.prototype.render = function () {
        return (React.createElement("div", { "data-hook": this.props.dataHook, className: s.root + " " + (this.props.noPadding ? s.noPadding : '') }, this.props.children));
    };
    PaymentMethodLayout.defaultProps = {
        dataHook: 'wcn-cashier-payments-method-layout',
    };
    return PaymentMethodLayout;
}(React.Component));
exports.default = PaymentMethodLayout;
//# sourceMappingURL=PaymentMethodLayout.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/PaymentMethodLayout/PaymentMethodLayout.js
// module id = 209
// module chunks = 0 1